export enum BREAKPOINT {
  XS = 490,
  SM = 768,
  MD = 1040,
  LG = 1800,
  XL = 1920,
}

export enum TimeChoices {
  TODAY = '0',
  LAST7DAYS = '1',
  LAST30DAYS = '2',
  CUSTOM = '3',
}

export enum Embedded {
  LIVE = '1',
  DEV = '0',
}

export enum RoleTheme {
  UNPUBLISHED = 'UNPUBLISHED',
  MAIN = 'MAIN',
  DEVELOPMENT = 'DEVELOPMENT',
}

export enum DateChoicesEnum {
  SINGLEDATE = 'single-date',
  DATETIME = 'date-time',
  DATETIMESLOT = 'date-time-slot',
}

export enum WorkingDayType {
  EVERYDAY = 'everyday',
  WEEKDAYS = 'weekdays',
  CUSTOM = 'custom',
}

export enum KindOfTimeType {
  SAME = 'same',
  DIFFERENT = 'different',
}

export enum AvailabilityType {
  ALL = 'all',
  SPECIFIC = 'specific',
  EXCLUDED = 'excluded',
  INCLUDED = 'included',
}

export enum LocationViewChoices {
  ALL = 0,
  PICKUP = 1,
  DELIVERY = 2,
}

export enum SubmitTone {
  CRITICAL = 'critical',
  DEFAULT = 'default',
}

export enum TypeDelete {
  LOCATION = 'location',
  ZONE = 'zone',
}

export enum WeekdayEnum {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  CUSTOM = -1,
}

export enum FrequencyEnum {
  EVERY_10_MINUTES = 'every-10-minutes',
  EVERY_15_MINUTES = 'every-15-minutes',
  EVERY_20_MINUTES = 'every-20-minutes',
  EVERY_30_MINUTES = 'every-30-minutes',
  EVERY_HOUR = 'every-hour',
  CUSTOM = 'custom',
}

export enum TimeUnitEnum {
  HOUR = 'hour',
  MINUTE = 'minute',
  DAY = 'day',
}

export enum SpecificType {
  SPECIFIC = 'specific',
  BLACKOUT = 'blackout',
}

export enum StatusOptions {
  ENABLE = '1',
  DISABLE = '0',
}

export enum TimeUnitOptions {
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
}

export enum DateRangeType {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export enum PostalCodeType {
  EXACT_CODE = 'exactCode',
  PARTIAL_POSTAL_CODE = 'partialPostal',
}

// WIDGET APPEARANCE

export enum LAYOUT_OPTIONS {
  DROPDOWN = 'dropdown',
  VERTICAL = 'vertical-radio',
  HORIZONTAL = 'horizontal-radio',
}

export enum DISPLAY_TYPE_OPTIONS {
  ICON = 'icon',
  TEXT = 'text',
  ICON_TEXT = 'icon-text',
}

export enum BORDER_RADIUS_OPTIONS {
  NONE = '0px',
  SMALL = '0.25em',
  MEDIUM = '0.5em',
  LARGE = '1em',
  EXTRA_LARGE = '2em',
}

export enum LOCATION_LAYOUT_OPTIONS {
  HORIZONTAL = 'horizontal',
  DROPDOWN = 'dropdown',
}

export enum ALIGNMENT_OPTIONS {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export enum CAPTION_LAYOUT_OPTIONS {
  LABEL = 'label',
  DROPDOWN = 'dropdown',
  DROPDOWN_MONTHS = 'dropdown-months',
  DROPDOWN_YEARS = 'dropdown-years',
}

export enum DAY_OF_WEEK_OPTIONS {
  SUNDAY = '0',
  MONDAY = '1',
  TUESDAY = '2',
  WEDNESDAY = '3',
  THURSDAY = '4',
  FRIDAY = '5',
  SATURDAY = '6',
}

export enum NAVIGATION_LAYOUT_OPTIONS {
  FIRST_LAYOUT = '1',
  SECOND_LAYOUT = '2',
}

export enum dateFormatEnum {
  DAY_MONTH_YEAR_WITH_WEEKDAYS = 'eeee, dd MMMM yyyy',
  MONTH_DAY_YEAR = 'MM-dd-yyyy',
  DAY_MONTH_YEAR = 'dd-MM-yyyy',
  DAY_MONTH_YEAR_DELIMITER = 'dd/MM/yyyy',
  DAY_MONTH_YEAR_WITH_WEEKDAYS_COMMAS = 'eee, dd MMM, yyyy',
  YEAR_MONTH_DATE = 'yyyy-MM-dd',
}

export enum timeFormatEnum {
  TWELVE_HOURS_FORMAT = 'h:mm aa',
  TWENTY_FOUR_HOURS_FORMAT = 'H:mm',
}

export enum LOCALE_OPTIONS {
  AF = 'af',
  AR = 'ar',
  AR_DZ = 'ar-DZ',
  AR_EG = 'ar-EG',
  AR_MA = 'ar-MA',
  AR_SA = 'ar-SA',
  AR_TN = 'ar-TN',
  AZ = 'az',
  BE = 'be',
  BE_TARASK = 'be-tarask',
  BG = 'bg',
  BN = 'bn',
  BS = 'bs',
  CA = 'ca',
  CKB = 'ckb',
  CS = 'cs',
  CY = 'cy',
  DA = 'da',
  DE = 'de',
  DE_AT = 'de-AT',
  EL = 'el',
  EN_AU = 'en-AU',
  EN_CA = 'en-CA',
  EN_GB = 'en-GB',
  EN_IE = 'en-IE',
  EN_IN = 'en-IN',
  EN_NZ = 'en-NZ',
  EN_US = 'en-US',
  EN_ZA = 'en-ZA',
  EO = 'eo',
  ES = 'es',
  ET = 'et',
  EU = 'eu',
  FA_IR = 'fa-IR',
  FI = 'fi',
  FR = 'fr',
  FR_CA = 'fr-CA',
  FR_CH = 'fr-CH',
  FY = 'fy',
  GD = 'gd',
  GL = 'gl',
  GU = 'gu',
  HE = 'he',
  HI = 'hi',
  HR = 'hr',
  HT = 'ht',
  HU = 'hu',
  HY = 'hy',
  ID = 'id',
  IS = 'is',
  IT = 'it',
  IT_CH = 'it-CH',
  JA = 'ja',
  JA_HIRA = 'ja-Hira',
  KA = 'ka',
  KK = 'kk',
  KM = 'km',
  KN = 'kn',
  KO = 'ko',
  LB = 'lb',
  LT = 'lt',
  LV = 'lv',
  MK = 'mk',
  MN = 'mn',
  MS = 'ms',
  MT = 'mt',
  NB = 'nb',
  NL = 'nl',
  NL_BE = 'nl-BE',
  NN = 'nn',
  OC = 'oc',
  PL = 'pl',
  PT = 'pt',
  PT_BR = 'pt-BR',
  RO = 'ro',
  RU = 'ru',
  SE = 'se',
  SK = 'sk',
  SL = 'sl',
  SQ = 'sq',
  SR = 'sr',
  SR_LATN = 'sr-Latn',
  SV = 'sv',
  TA = 'ta',
  TE = 'te',
  TH = 'th',
  TR = 'tr',
  UG = 'ug',
  UK = 'uk',
  UZ = 'uz',
  UZ_CYRL = 'uz-Cyrl',
  VI = 'vi',
  ZH_CN = 'zh-CN',
  ZH_HK = 'zh-HK',
  ZH_TW = 'zh-TW',
}

export enum SIZE_OPTIONS {
  SM = '1.75em',
  MD = '2em',
  LG = '2.25em',
  XL = '2.5em',
  XXL = '2.75em',
  XXXL = '3em',
}

export enum COLOR_SCHEME_OPTIONS {
  LIGHT = 'light',
  DARK = 'dark',
  CUSTOM = 'custom',
}

export enum timeFormatValue {
  TWELVE_HOURS = '12',
  TWENTY_FOUR_HOURS = '24',
}

export enum keyOfWidgetSetting {
  HEADER = 'header',
  BODY = 'body',
  CALENDAR = 'calendar',
}

export enum TRANSPARENT_OPTIONS {
  TRANSPARENT = 0,
  OPAQUE = 1,
}

export enum METHOD_OPTIONS {
  PICKUP = 0,
  DELIVERY = 1,
  SHIPPING = 2,
}

export enum SETUP_GUIDE_OPTIONS {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
  FIFTH = 5,
  SIXTH = 6,
}

export enum ROLE_SHOP_THEME {
  MAIN = 'MAIN',
  UNPUBLISHED = 'UNPUBLISHED',
}

export enum EMBEDDED_APP_STATUS {
  EMBEDDED = '1',
  NON_EMBEDDED = '0',
}

export enum SETTING_TYPE {
  SHIPPING = 'shipping',
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
}

export enum GOOGLE_API_STATUS {
  INVALID = 'REQUEST_DENIED',
  VALID = 'OK',
}

export enum OrderLimitType {
  LIMIT_PER_DAY = 'per-day',
  LIMIT_PER_TIMESLOT = 'per-time-slot',
}

export enum ProductAvailabilityTable {
  PRODUCT = 0,
  COLLECTION = 1,
}

export enum ProductOverrideType {
  OVERRIDE_SPECIFIC_WORKING_DAYS = 1,
  OVERRIDE_HOLIDAYS = 2,
  OVERRIDE_DATE_RANGES = 3,
}

export enum ProductOverrideAction {
  ADD_OVERRIDE_RULE = 'addOverrideRule',
  REMOVE_OVERRIDE_RULE = 'removeOverrideRule',
  ADD_DATE_RANGES = 'addDateRange',
  UPDATE_DATE_RANGES = 'updateDateRange',
  REMOVE_DATE_RANGES = 'removeDateRange',
  CHOOSE_PRODUCTS = 'chooseProducts',
  CHOOSE_COLLECTIONS = 'chooseCollections',
  CHANGE_OVERRIDE_PREPARATION_DAY = 'changeOverridePreparationDay',
  CHANGE_OVERRIDE_DATERANGE_DAY = 'changeOverrideDaterangeDay',
}

export enum TimeTypeTabs {
  SAME = 0,
  DIFFERENT = 1,
}

export enum ClassEnum {
  Main = 'ot-dingdoong-main',
  Header = 'ot-dingdoong-header',
  HeaderTitle = 'ot-dingdoong-header__title',
  HeaderAdditionalMessage = 'ot-dingdoong-header-additional-message',
  HeaderRadio = 'ot-dingdoong-header__radio',
  HeaderRadioLabel = 'ot-dingdoong-header__radio-label',
  HeaderRadioLabelText = 'ot-dingdoong-header__radio-label-text',
  RadioInput = 'ot-dingdoong-radio-input',
  Dropdown = 'ot-dingdoong-dropdown',
  DropdownLayer = 'ot-dingdoong-dropdown__layer',
  DropdownButton = 'ot-dingdoong-dropdown__button',
  DropdownLabelContainer = 'ot-dingdoong-dropdown__label-container',
  DropdownLabelPrefix = 'ot-dingdoong-dropdown__label-prefix',
  DropdownLabel = 'ot-dingdoong-dropdown__label',
  DropdownContent = 'ot-dingdoong-dropdown__content',
  DropdownContentItem = 'ot-dingdoong-dropdown__content-item',
  DropdownButtonIcon = 'ot-dingdoong-dropdown__button-icon',
  HeaderDropdownContentItem = 'ot-dingdoong-header__dropdown-content-item',
  HeaderDropdownContentItemIcon = 'ot-dingdoong-header__dropdown-content-item-icon',
  HeaderDropdownContentItemText = 'ot-dingdoong-header__dropdown-content-item-text',
  Disabled = 'ot-dingdoong-disabled',
  // pickup
  Pickup = 'ot-dingdoong-pickup',
  PickupLabel = 'ot-dingdoong-pickup__label',
  PickupLocationList = 'ot-dingdoong-pickup__location-list',
  PickupLocationItem = 'ot-dingdoong-pickup__location-item',
  PickupLocationItemContainer = 'ot-dingdoong-pickup__location-item-container',
  PickupLocationItemTitle = 'ot-dingdoong-pickup__location-item-title',
  PickupLocationItemDescription = 'ot-dingdoong-pickup__location-item-description',
  // delivery
  Delivery = 'ot-dingdoong-delivery',
  DeliveryLabel = 'ot-dingdoong-delivery__label',
  ZipcodeWrapper = 'ot-dingdoong-delivery__zipcode-wrapper',
  ZipcodeInput = 'ot-dingdoong-delivery__zipcode-input',
  ZipcodeSubmitButton = 'ot-dingdoong-delivery__zipcode-submit-button',
  DeliveryEligibleMessage = 'ot-dingdoong-delivery__eligible-message',
  DeliveryErrorMessage = 'ot-dingdoong-delivery__error-message',
  // day picker
  DayPickerContainer = 'ot-dingdoong-day-picker-container',
  DayPickerLabel = 'ot-dingdoong-day-picker__label',
  Calendar = 'ot-dingdoong-calendar',
  CalendarMonths = 'ot-dingdoong-calendar__months',
  CalendarMonth = 'ot-dingdoong-calendar__month',
  CalendarMonthCaption = 'ot-dingdoong-calendar__month-caption',
  CalendarCaptionLabel = 'ot-dingdoong-calendar__caption-label',
  CalendarNav = 'ot-dingdoong-calendar__nav',
  CalendarMonthGrid = 'ot-dingdoong-calendar__month-grid',
  CalendarWeekdays = 'ot-dingdoong-calendar__weekdays',
  CalendarWeekday = 'ot-dingdoong-calendar__weekday',
  CalendarWeek = 'ot-dingdoong-calendar__week',
  CalendarDay = 'ot-dingdoong-calendar__day',
  CalendarDayButton = 'ot-dingdoong-calendar__day-button',
  CalendarWeekNumber = 'ot-dingdoong-calendar__week-number',
  CalendarRangeStart = 'ot-dingdoong-calendar__range-start',
  CalendarRangeEnd = 'ot-dingdoong-calendar__range-end',
  CalendarSelected = 'ot-dingdoong-calendar__selected',
  CalendarToday = 'ot-dingdoong-calendar__today',
  CalendarOutside = 'ot-dingdoong-calendar__outside',
  CalendarDisabled = 'ot-dingdoong-calendar__disabled',
  CalendarRangeMiddle = 'ot-dingdoong-calendar__range-middle',
  CalendarHidden = 'ot-dingdoong-calendar__hidden',
  CalendarNextMonthButton = 'ot-dingdoong-calendar__next-month-button',
  CalendarPreviousMonthButton = 'ot-dingdoong-calendar__previous-month-button',
  CalendarPopoverButton = 'ot-dingdoong-calendar__popover-button',
  CalendarFooter = 'ot-dingdoong-calendar__footer',
  // time picker
  TimePickerContainer = 'ot-dingdoong-time-picker-container',
  TimePickerLabel = 'ot-dingdoong-time-picker__label',
  // additional message
  AdditionalMessage = 'ot-dingdoong-additional-message',
  AdditionalMessageMinimumValue = 'ot-dingdoong-additional-message-minimum-value',
  AdditionalMessageMinimumWeight = 'ot-dingdoong-additional-message-minimum-weight',
  // error message
  RequiredMessage = 'ot-dingdoong-required-message',
  MinimumOrderAmountError = 'ot-dingdoong-minimum-order-amount-error',
}

export enum HeaderRadioDirection {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum PLAN_ENUM {
  MONTHLY = 0,
  YEARLY = 1,
}

export enum PricingPlan {
  Free = 'free',
  Essential = 'essential',
  Smart = 'smart',
  Enterprise = 'enterprise',
}

export enum PlanSubscription {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum KindOfOverrideRules {
  EARLIEST = 'earliest',
  LATEST = 'latest',
}

export enum STATUS_CODE {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
}

export enum ONBOARDING_STEP {
  WELCOME = 0,
  EMBEDDED_APP = 1,
  FINISH = 3,
}

export enum ONBOARDING_CUTOFF {
  BEFORE = 0,
  AFTER = 1,
}

export enum ORDER_REPORT_CSV {
  CURRENT_PAGE = 'current',
  ALL_PAGE = 'all',
}

export enum ORDER_FULFILLMENT_TYPE {
  PICKUP = '1',
  DELIVERY = '2',
  SHIPPING = '3',
}

export enum ORDER_DUE_DATE_TYPE {
  TODAY = '0',
  TOMORROW = '1',
  NO_DATE = '2',
  CUSTOM_DATE = '3',
}

export enum ORDER_STATUS_TYPE {
  UNFULFILLED = 'UNFULFILLED',
  FULFILLED = 'FULFILLED',
  PICKUP = 'READY_PICK_UP',
  DELIVERY = 'READY_DELIVERY',
  DISPATCHED = 'DISPATCH',
  CLOSED = 'CLOSED',
}

export enum ORDER_REPORT_CSV_TYPE {
  ALL_PAGE = 1,
  CURRENT_PAGE = 2,
  SPECIFIC = 3,
}

export enum WIDGET_SETTING_CHOICE {
  POSITION = 0,
  DESIGN = 1,
}

export enum WIDGET_DESIGN_CHOICE {
  GENERAL = 0,
  TEXTFIELD = 1,
  COLOUR = 2,
  ADVANCED = 3,
}

export enum WIDGET_DISPLAY_CHOICE {
  CART = 'cart',
  PRODUCT = 'product',
}

export enum WIDGET_POSITION_CHOICE {
  BEFORE_BEGIN = 'beforebegin',
  AFTER_BEGIN = 'afterbegin',
  BEFORE_END = 'beforeend',
  AFTER_END = 'afterend',
}

export enum BOOLEAN_STRING {
  TRUE = '1',
  FALSE = '0',
}

export enum CHECKOUT_PAGE_OPTION {
  OFF = 0,
  ON = 1,
}

export enum DELIVERY_RESTRICTION_CHOICE {
  NO_VALID = 0,
  POSTAL_CODE_MATCH = 1,
  CUSTOM = 2,
}

export enum DELIVERY_RESTRICTION_CUSTOM {
  KM = 'km',
  MI = 'mi',
}

export enum EChangeMethodShipping {
  NONE = 0,
  PRODUCT_PAGE = 1,
  CART_PAGE = 2,
}

export enum EmailTypeEnum {
  ReadyForPickup = 1,
  OutForDelivery = 2,
}

export enum OrderTagEnum {
  SHIPPING_NAME = 'shipping_name',
  SHIPPING_DATE = 'shipping_date',
  SHIPPING_TIME = 'shipping_time',
  SHIPPING_DAY = 'shipping_day',
  DELIVERY_NAME = 'delivery_name',
  DELIVERY_DATE = 'delivery_date',
  DELIVERY_TIME = 'delivery_time',
  DELIVERY_DAY = 'delivery_day',
  PICKUP_NAME = 'pickup_name',
  PICKUP_DATE = 'pickup_date',
  PICKUP_TIME = 'pickup_time',
  PICKUP_DAY = 'pickup_day',
}
